module.exports = __webpack_public_path__ + "img/caring_business@3x.caa6a2a7.png";